import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import { primaryLightest, backgroundDark, secondaryMain } from '../../../constants/colors';

const useStyles = makeStyles((theme) => ({
  root: {
    background: primaryLightest,
  },
  header: {
    fontSize: 11,
    fontWeight: 600,
    color: secondaryMain,
    paddingLeft: 24,
    paddingTop: 4,
    paddingBottom: 1,
    borderTop: `1px solid ${backgroundDark}`,
  },
  list: {
    padding: 0,
    '& > a > div': {
      marginLeft: 48,
      width: 'calc(100% - 48px)',
    },
  },
}));

export default function NestedSubMenu(props) {
  const { label, items } = props;
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Typography className={classes.header}>{label}</Typography>
      <List className={classes.list}>
        {items}
      </List>
    </div>
  );
}
